import Home from '../views/mps/Home';
import ChiAmi from '../views/mps/ChiAmi';
import Assicurati from '../views/mps/Assicurati';
import Premio from '../views/mps/Premio';
// Call Me Back MPS disabilitato temporaneamente (dismissione flusso SFTP MPS, 07/2026)
// import Appuntamento from '../views/mps/Appuntamento';
import Recupera from '../views/mps/Recupera';
import Salva from '../views/mps/Salva';
import Thanks from '../views/mps/Thanks';

export default [
    //MPS
    {
        path: '/mps',
        name: 'home_mps',
        meta: {layout: "master-mps"},
        component: Home
    },
    {
        path: '/mps/chi_ami',
        name: 'chiAmi_mps',
        meta: {layout: "master-step-mps"},
        component: ChiAmi
    },
    {
        path: '/mps/parlaci',
        name: 'assicurati_mps',
        meta: {layout: "master-step-mps"},
        component: Assicurati
    },
    {
        path: '/mps/premio',
        name: 'premio_mps',
        meta: {layout: "master-mobile-mps"},
        component: Premio
    },
    // Call Me Back MPS disabilitato temporaneamente (dismissione flusso SFTP MPS, 07/2026):
    // la pagina "Ti richiamiamo noi" non è più raggiungibile, redirect al quotatore.
    {
        path: '/mps/appuntamento',
        name: 'appuntamento_mps',
        redirect: {name: 'home_mps'}
    },
    {
        path: '/mps/salva',
        name: 'salva_mps',
        meta: {layout: "master-step-mps"},
        component: Salva
    },
    {
        path: '/mps/recupera/:token',
        name: 'recupera_mps',
        meta: {layout: "master-mps"},
        component: Recupera
    },
    {
        path: '/mps/thanks',
        name: 'thanks_mps',
        meta: {layout: "master-mps"},
        component: Thanks
    }
];
